@for (item of itemArray; track item) {
  <div class="fn-rating">
    <input type="radio" [name]="item.name" [value]="item.id" [checked]="item.isSelected">
    <label (click)="onLabelClick(item)"></label>
  </div>
}
